import { HttpResponse, HttpStatusEnum } from '@core/api';
import { IncompleteOrder, IncompleteOrderDTO } from '../interfaces';

export class LayoutMapper {
    public static mapGetIncompleteOrdersData(data: { orders: IncompleteOrderDTO[] }): HttpResponse<IncompleteOrder[]> {
        return {
            status: HttpStatusEnum.SUCCESS,
            data: data.orders.map(order => {
                return {
                    orderName: order.compositeName,
                    numberOfReactions: order.numberOfReactions,
                    orderId: order.orderId,
                    lastSaved: order.updatedAt,
                };
            }),
        };
    }
}
